import React, { useContext } from "react";
import themeContext from "../../../context/theme/ThemeContext";

const ColorLutIcon = ({ color }) => {
  const { themeName } = useContext(themeContext);
  const isActive = color === "#0085FF";

  const borderColor      = isActive ? "#0044bb" : (themeName === "light" ? "#000000" : color);
  const intersectColor   = isActive ? "#0044bb" : (themeName === "light" ? "#000000" : color);
  const intersectOpacity = isActive ? 0.55 : 0.25;

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className="active-nav-icon" xmlns="http://www.w3.org/2000/svg">
      <defs>
        {/* Mask that reveals only the intersection of both circles */}
        <mask id="fusionIntersectMask">
          <circle cx="6.5" cy="10.5" r="5.5" fill="white" />
        </mask>
      </defs>

      {/* Intersection fill — circle 2 clipped to circle 1's area */}
      <circle cx="11.5" cy="7.5" r="5.5"
        fill={intersectColor}
        fillOpacity={intersectOpacity}
        mask="url(#fusionIntersectMask)"
      />

      {/* Circle outlines only */}
      <circle cx="6.5"  cy="10.5" r="5.5" fill="none" stroke={borderColor} strokeWidth="1.5" />
      <circle cx="11.5" cy="7.5"  r="5.5" fill="none" stroke={borderColor} strokeWidth="1.5" />
    </svg>
  );
};

export default ColorLutIcon;
